import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useBreakpoints, WebLocation } from '../../customHooks/useBreakpoints';

export enum Type {
    horizontal = 'horizontal',
    vertical = 'vertical',
}

interface SpaceProps {
    type?: Type;
    value?: number;
    shrinkable?: boolean;
}

const Space: FC<SpaceProps> = (props): ReactElement => {
    const { type = Type.vertical, value = 0.5, shrinkable = true } = props;
    const { isMobileSize } = useBreakpoints(WebLocation.FLOW);
    const classes = useStyles(isMobileSize && value >= 3 ? value - 1 : value)({});
    const activeClasses: string = type === Type.horizontal ? classes.horizontal : classes.vertical;
    const finalClasses: string = !shrinkable ? `${activeClasses} ${classes.notShrinkable}` : activeClasses;

    return <div className={finalClasses} />;
};

const useStyles = (spaceValue: number) =>
    makeStyles((theme: Theme) =>
        createStyles({
            horizontal: {
                width: theme.spacing(spaceValue),
            },
            vertical: {
                height: theme.spacing(spaceValue),
            },
            notShrinkable: {
                flexShrink: 0,
            },
        }),
    );

export default Space;
